/**
 * IVA con el que el catálogo del SaaS presenta los precios.
 *
 * Debe coincidir con el `IvaRate` de la API, que hoy lo repite como constante privada en cada
 * consulta que lo necesita. Si allá cambia, aquí también.
 */
export const IVA_RATE = 0.16;

/** Importe que ve el cliente: el capturado más su IVA. */
export const withIva = (base: number): number => base + base * IVA_RATE;

const MXN = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
});

export const formatMxn = (amount: number): string => MXN.format(amount);
